import { render, staticRenderFns } from "./form-signup.vue?vue&type=template&id=f8cd0c60&"
import script from "./form-signup.vue?vue&type=script&lang=js&"
export * from "./form-signup.vue?vue&type=script&lang=js&"
import style0 from "./form-signup.vue?vue&type=style&index=0&id=f8cd0c60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports